import React, { PropTypes, Component } from 'react'
import style from './style.css';
import withMedia from '../../../containers/withmedia';

class Scroller extends Component {
    render() {
        const item_width = this.props.browser.lessThan.extraSmall ? 240 : 300 ;
        const windowWidth = "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
        const scroll_width = this.props.width //items ? ( Object.keys(items).length * windowWidth)  : windowWidth
        return (
            <div className={ style.scroller } style={{ WebkitScrollSnapPointsX: `repeat(${ windowWidth - 38}px)`, scrollBehavior: 'smooth' }}>
                <div style={{ width: `${scroll_width}px`}} className={ style.scrollingContainer } >
                    { this.props.items }
                </div>
            </div>
        )
    }
}

export default withMedia(Scroller)



// WEBPACK FOOTER //
// ./src/components/pagescreen/scroller/index.js